// extracted by mini-css-extract-plugin
module.exports = {"logo":"styles-module__logo___LJLDb"};